import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UpdateContactRequest, UpdateContactResponse } from '../../interfaces/updateContact.interface';
import { Global } from '../global';

@Injectable({
  providedIn: 'root'
})
export class UpdateContactService {

  private API_URL: string;

  constructor(private httpClient: HttpClient) {
    this.API_URL = Global.url + '/cx/update_contact'
  }
  updateContact(token: string, request: UpdateContactRequest): Observable<UpdateContactResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    return this.httpClient.post<UpdateContactResponse>(this.API_URL, request, { headers });
  }

  
}
